<template>
  <v-dialog v-model="dialog" persistent max-width="1400px">
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon color="amber" class="mr-2">mdi-chart-line</v-icon>
        <span>Histórico de Tiempo de Ciclo</span>
        <v-spacer></v-spacer>
        
            <v-btn-toggle 
            v-model="vistaActual" 
            mandatory 
            dense 
            class="mr-3 toggle-buttons"
            color="primary"
            background-color="grey lighten-3"
            >
            <v-btn small value="completo" dark>
                <v-icon small>mdi-chart-line</v-icon>
                <span class="ml-1">Completo</span>
            </v-btn>
            <v-btn small value="horas" dark>
                <v-icon small>mdi-clock-outline</v-icon>
                <span class="ml-1">Por Hora</span>
            </v-btn>
            </v-btn-toggle>

        <v-switch
          v-model="extenderHoraActual"
          dense
          hide-details
          color="primary"
          class="mr-3 mt-0 pt-0"
          label="Hasta la hora actual"
        ></v-switch>

        <v-btn icon @click="cerrar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row dense class="mb-4">
          <v-col cols="3">
            <v-card outlined class="pa-3">
              <div class="caption text-uppercase grey--text text--darken-1">TC Programado</div>
              <div class="title font-weight-bold" style="color: #4CAF50;">
                {{ tcProgramadoTxt }}
              </div>
            </v-card>
          </v-col>
          <v-col cols="3">
            <v-card outlined class="pa-3">
              <div class="caption text-uppercase grey--text text--darken-1">TC Real Mediana</div>
              <div class="title font-weight-bold" style="color: #FFC107;">
                {{ tcRealMedianaTxt }}
              </div>
            </v-card>
          </v-col>
          <v-col cols="3">
            <v-card outlined class="pa-3">
              <div class="caption text-uppercase grey--text text--darken-1">Diferencia</div>
              <div 
                class="title font-weight-bold"
                :style="{ color: diferenciaTc >= 0 ? '#F44336' : '#4CAF50' }"
              >
                {{ diferenciaTcTxt }}
              </div>
            </v-card>
          </v-col>
          <v-col cols="3">
            <v-card outlined class="pa-3">
              <div class="caption text-uppercase grey--text text--darken-1">Variación</div>
              <div 
                class="title font-weight-bold"
                :style="{ color: variacionPct >= 0 ? '#F44336' : '#4CAF50' }"
              >
                {{ variacionPctTxt }}
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-if="vistaActual === 'horas' && horasDisponibles.length" dense class="mb-3">
          <v-col cols="12">
            <v-card outlined class="pa-3">
              <div class="d-flex align-center">
                <v-icon class="mr-2">mdi-clock-outline</v-icon>
                <span class="font-weight-medium mr-3">Selecciona una hora:</span>
                <v-chip-group v-model="horaSeleccionada" mandatory active-class="primary--text">
                  <v-chip
                    v-for="(hora, idx) in horasDisponibles"
                    :key="idx"
                    :value="idx"
                    outlined
                    small
                  >
                    {{ hora.label }}
                    <span class="ml-2 grey--text text--darken-1 caption">
                      ({{ hora.count }})
                    </span>
                  </v-chip>
                </v-chip-group>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-col v-if="loading" cols="12" class="text-center py-8">
          <v-progress-circular
            :size="70"
            :width="7"
            color="amber"
            indeterminate
          ></v-progress-circular>
          <h3 class="mt-4">Cargando datos históricos...</h3>
        </v-col>

        <v-card v-else-if="!loading && tieneSeriesData" outlined>
          <apexchart
            ref="tcChart"
            :key="chartKey"
            type="line"
            height="500"
            :options="chartOptions"
            :series="chartSeries"
          />
        </v-card>

        <v-alert v-else color="blue-grey" text class="mb-0">
          <div class="text-center" style="font-size: 16px">
            No hay datos disponibles para el período seleccionado
          </div>
        </v-alert>

        <v-row v-if="vistaActual === 'horas' && estadisticasHoraActual" dense class="mt-3">
          <v-col cols="12">
            <v-card outlined class="pa-3">
              <div class="subtitle-2 mb-2">
                <v-icon small class="mr-1">mdi-chart-bar</v-icon>
                Estadísticas de {{ horasDisponibles[horaSeleccionada].label }}
              </div>
              <v-row dense>
                <v-col cols="3">
                  <div class="caption grey--text">Puntos de datos</div>
                  <div class="body-1 font-weight-bold">{{ estadisticasHoraActual.count }}</div>
                </v-col>
                <v-col cols="3">
                  <div class="caption grey--text">TC Mínimo</div>
                  <div class="body-1 font-weight-bold">{{ estadisticasHoraActual.min.toFixed(1) }} s</div>
                </v-col>
                <v-col cols="3">
                  <div class="caption grey--text">TC Máximo</div>
                  <div class="body-1 font-weight-bold">{{ estadisticasHoraActual.max.toFixed(1) }} s</div>
                </v-col>
                <v-col cols="3">
                  <div class="caption grey--text">Promedio</div>
                  <div class="body-1 font-weight-bold">{{ estadisticasHoraActual.avg.toFixed(1) }} s</div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="cerrar">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';

export default {
  name: 'HistoricoTCGrafica',
  
  props: {
    value: { type: Boolean, default: false },
    idMaquinaIns: { type: Number, required: true },
    fecha: { type: String, required: true },
    turno: { type: Object, required: true },
    maquinaNombre: { type: String, default: '' },
    tcProgramado: { type: Number, default: 0 },
    tcRealMediana: { type: Number, default: 0 },
  },

  data() {
    return {
      loading: false,
      datosHistoricos: [],
      vistaActual: 'completo',
      extenderHoraActual: true,
      horaSeleccionada: 0,
      ultimaFirmaConsulta: '',
      colores: {
        tcReal: '#FFC107',
        tcProgramado: '#4CAF50',
        tcMediana: '#FF6B6B',
        meta: '#90A4AE',
      }
    };
  },

  computed: {
    dialog: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); }
    },
    firmaConsulta() {
      const id = Number(this.idMaquinaIns || 0);
      const fecha = String(this.fecha || '').slice(0, 10);
      const ini = String(this.turno?.inicio || '');
      const fin = String(this.turno?.fin || '');

      if (id <= 0) return '';
      if (fecha.length < 10) return '';
      if (ini.length < 4 || fin.length < 4) return '';

      return `${id}|${fecha}|${ini}|${fin}`;
    },

    horasDisponibles() {
      if (!this.datosHistoricos.length) return [];
      
      const moment = this.$moment || require('moment');
      const porHora = new Map();

      this.datosHistoricos.forEach(d => {
        const hora = moment(d.timestamp).format('HH:00');
        if (!porHora.has(hora)) {
          porHora.set(hora, []);
        }
        porHora.get(hora).push(d);
      });

      return Array.from(porHora.entries())
        .sort((a, b) => a[0].localeCompare(b[0]))
        .map(([hora, datos]) => ({
          label: hora,
          datos,
          count: datos.length
        }));
    },

    datosFiltrados() {
      if (this.vistaActual === 'completo') {
        return this.datosHistoricos;
      }
      
      const horaActual = this.horasDisponibles[this.horaSeleccionada];
      return horaActual ? horaActual.datos : [];
    },

    ultimoTimestamp() {
      if (!this.datosFiltrados || !this.datosFiltrados.length) return null;
      const ts = this.datosFiltrados[this.datosFiltrados.length - 1].timestamp;
      const n = Number(ts);
      return Number.isFinite(n) ? n : null;
    },

    estadisticasHoraActual() {
      if (this.vistaActual !== 'horas' || !this.datosFiltrados.length) return null;

      const valores = this.datosFiltrados.map(d => d.tcReal);
      return {
        count: valores.length,
        min: Math.min(...valores),
        max: Math.max(...valores),
        avg: valores.reduce((a, b) => a + b, 0) / valores.length
      };
    },

    tcRealMedianaCalculada() {
      if (!this.datosHistoricos || !this.datosHistoricos.length) return 0;
      
      const valores = this.datosHistoricos
        .map(d => d.tcReal)
        .filter(v => Number.isFinite(v) && v > 0)
        .sort((a, b) => a - b);
      
      if (!valores.length) return 0;
      
      const mid = Math.floor(valores.length / 2);
      
      if (valores.length % 2 === 0) {
        return (valores[mid - 1] + valores[mid]) / 2;
      }
      return valores[mid];
    },

    tcProgramadoTxt() {
      const s = Number(this.tcProgramado);
      if (!Number.isFinite(s) || s <= 0) return '—';
      return `${s.toFixed(1)} seg/pza`;
    },

    tcRealMedianaTxt() {
      const s = this.tcRealMedianaCalculada;
      if (!Number.isFinite(s) || s <= 0) return '—';
      return `${s.toFixed(1)} seg/pza`;
    },

    diferenciaTc() {
      return this.tcRealMedianaCalculada - Number(this.tcProgramado);
    },

    diferenciaTcTxt() {
      const d = this.diferenciaTc;
      if (!Number.isFinite(d)) return '—';
      const sign = d > 0 ? '+' : '';
      return `${sign}${d.toFixed(1)} seg`;
    },

    variacionPct() {
      const prog = Number(this.tcProgramado);
      if (!prog) return 0;
      return ((this.diferenciaTc / prog) * 100);
    },

    variacionPctTxt() {
      const v = this.variacionPct;
      if (!Number.isFinite(v)) return '—';
      const sign = v > 0 ? '+' : '';
      return `${sign}${v.toFixed(1)}%`;
    },

    tieneSeriesData() {
      return this.chartSeries.some(s => s.data && s.data.length > 0);
    },

    chartKey() {
      return `${this.vistaActual}|${this.horaSeleccionada}|${this.extenderHoraActual}`;
    },

    chartSeries() {
      if (!this.datosFiltrados || !this.datosFiltrados.length) return [];

      const serieReal = {
        name: 'TC Real (seg/pza)',
        type: 'line',
        data: this.datosFiltrados.map(d => ({
          x: d.timestamp,
          y: d.tcReal
        })),
        color: this.colores.tcReal
      };

      const serieProgramado = {
        name: 'TC Programado (seg/pza)',
        type: 'line',
        data: this.datosFiltrados.map(d => ({
          x: d.timestamp,
          y: this.tcProgramado
        })),
        color: this.colores.tcProgramado
      };

      const serieMediana = {
        name: 'TC Real Mediana (seg/pza)',
        type: 'line',
        data: this.datosFiltrados.map(d => ({
          x: d.timestamp,
          y: this.tcRealMedianaCalculada
        })),
        color: this.colores.tcMediana
      };

      return [serieReal, serieProgramado, serieMediana];
    },

    chartOptions() {
      const formatoX = this.vistaActual === 'horas' ? 'HH:mm:ss' : 'HH:mm';

      const options = {
        chart: {
          type: 'line',
          height: 500,
          toolbar: { 
            show: true,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true
            }
          },
          zoom: { 
            enabled: true,
            type: 'x',
            autoScaleYaxis: true
          },
          animations: {
            enabled: true,
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150
            }
          }
        },
        stroke: {
          width: [3, 2, 2],
          curve: 'smooth',
          dashArray: [0, 5, 8]
        },
        markers: {
          size: this.vistaActual === 'horas' ? [5, 0, 0] : [4, 0, 0],
          strokeWidth: 2,
          strokeColors: '#fff',
          hover: { 
            size: this.vistaActual === 'horas' ? 8 : 6,
            sizeOffset: 3
          }
        },
        xaxis: {
          type: 'datetime',
          labels: {
            format: formatoX,
            datetimeUTC: false,
            style: {
              fontSize: '11px'
            }
          },
          title: { text: 'Tiempo' },
          tooltip: {
            enabled: true
          }
        },
        yaxis: {
          title: { text: 'Tiempo de Ciclo (seg/pza)' },
          labels: {
            formatter: function(v) {
              return Number(v || 0).toFixed(1) + ' s';
            }
          },
          min: 0,
          forceNiceScale: true
        },
        tooltip: {
          shared: true,
          intersect: false,
          x: {
            format: 'dd/MM/yyyy HH:mm:ss'
          },
          y: {
            formatter: function(v) {
              return Number(v || 0).toFixed(2) + ' seg/pza';
            }
          }
        },
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'center',
          fontSize: '13px',
          markers: {
            width: 12,
            height: 12,
            radius: 2
          }
        },
        grid: {
          padding: { left: 8, right: 8 },
          borderColor: '#e0e0e0',
          strokeDashArray: 3
        },
        annotations: {
          yaxis: this.tcProgramado > 0 ? [{
            y: this.tcProgramado,
            borderColor: this.colores.meta,
            strokeDashArray: 4,
            label: {
              text: 'Meta: ' + this.tcProgramado.toFixed(1) + ' seg',
              style: {
                fontSize: '11px',
                background: this.colores.meta,
                color: '#fff'
              }
            }
          }] : []
        },
        dataLabels: {
          enabled: this.vistaActual === 'horas' && this.datosFiltrados.length < 100,
          enabledOnSeries: [0],
          style: {
            fontSize: '10px',
            colors: ['#424242']
          },
          background: {
            enabled: true,
            foreColor: '#fff',
            borderRadius: 2,
            padding: 4,
            opacity: 0.9
          },
          formatter: function(val) {
            return val ? val.toFixed(1) : '';
          }
        }
      };

      // Opcional: extender el eje X hasta la hora actual, aunque no haya datos.
      if (this.extenderHoraActual && this.ultimoTimestamp) {
        const ahora = Date.now();

        if (ahora > this.ultimoTimestamp) {
          options.xaxis.max = ahora;

          // Marcar el tiempo muerto (sin datos) desde el último dato hasta ahora en rojo.
          options.annotations.xaxis = [{
            x: this.ultimoTimestamp,
            x2: ahora,
            fillColor: '#F44336',
            opacity: 0.12,
            borderColor: '#F44336',
            label: {
              text: 'Sin datos (tiempo muerto)',
              borderColor: '#F44336',
              position: 'top',
              orientation: 'horizontal',
              style: {
                fontSize: '11px',
                background: '#F44336',
                color: '#fff'
              }
            }
          }];
        }
      }

      return options;
    }
  },

  methods: {
    async precargarHistorico(forzar = false) {
      const firma = this.firmaConsulta;
      if (!firma) return;

      if (!forzar && firma === this.ultimaFirmaConsulta) return;

      await this.obtenerDatosHistoricos();
      this.ultimaFirmaConsulta = firma;
    },
    async obtenerDatosHistoricos() {
      if (!this.idMaquinaIns || !this.fecha || !this.turno || !this.turno.inicio) {
        return;
      }

      this.loading = true;
      this.datosHistoricos = [];

      try {
        const { data: tokens } = await axios.get('/SensorDatos/TokensPorMaquina', {
          params: { idMaquinaIns: this.idMaquinaIns }
        });

        if (!tokens || tokens.length === 0) {
          return;
        }

        const token = tokens[0];
        const moment = this.$moment || require('moment');

        const fechaBase = moment(this.fecha);
        const [horaI, minI] = (this.turno.inicio || '00:00').split(':');
        const [horaF, minF] = (this.turno.fin || '23:59').split(':');

        let inicio = fechaBase.clone().hour(+horaI).minute(+minI).second(0);
        let fin = fechaBase.clone().hour(+horaF).minute(+minF).second(59);

        if (fin.isBefore(inicio)) {
          fin.add(1, 'day');
        }

        const params = {
          inicio: inicio.format("YYYY-MM-DD HH:mm:ss"),
          fin: fin.format("YYYY-MM-DD HH:mm:ss"),
          idMaquinaIns: this.idMaquinaIns,
          key: token,
        };

        const resp = await axios.get("/SensorDatos/SeriesRealtimePostgres", { params });
        const series = resp.data?.series || [];

        if (series.length > 0 && series[0].data) {
          this.datosHistoricos = series[0].data
            .map(punto => ({
              timestamp: punto.x,
              tcReal: Number(punto.y)
            }))
            .filter(d => Number.isFinite(d.tcReal) && d.tcReal > 0)
            .sort((a, b) => a.timestamp - b.timestamp);
        }

      } catch (error) {
      } finally {
        this.loading = false;
      }
    },

    cerrar() {
      this.dialog = false;
    }
  },

  watch: {
    value(v) {
      if (v) {
        this.precargarHistorico(true);
      }
    },
    firmaConsulta: {
      immediate: true,
      handler() {
        this.precargarHistorico(false);
      }
    },
    tcRealMedianaCalculada(v) {
      this.$emit('update:tcRealMediana', Number(v || 0))
    },
    
    vistaActual() {
      this.horaSeleccionada = 0;
    }
  }
};
</script>

<style scoped>
.v-card__title {
  font-size: 1.25rem;
  font-weight: 600;
}

.caption {
  font-size: 11px;
  letter-spacing: 0.4px;
}

.title {
  font-size: 24px;
  line-height: 1.2;
}

.v-chip-group {
  flex-wrap: wrap;
  max-height: 200px;
  overflow-y: auto;
}

.v-chip {
  margin: 2px !important;
}
.toggle-buttons .v-btn:not(.v-btn--active) {
  background-color: #e0e0e0 !important;
  color: #424242 !important;
}

.toggle-buttons .v-btn:not(.v-btn--active) .v-icon {
  color: #424242 !important;
}

.toggle-buttons .v-btn.v-btn--active {
  background-color: #1976D2 !important;
  color: white !important;
}

.toggle-buttons .v-btn.v-btn--active .v-icon {
  color: white !important;
}

/* Hover */
.toggle-buttons .v-btn:not(.v-btn--active):hover {
  background-color: #bdbdbd !important;
}
</style>
